<template>
    <b-container fluid style="display: flex; align-content: center; justify-content: center" class="col-12">
        <img src="@/assets/IO-website-transparant-300x175.png" class="ioImage">
        <b-card class="signIn-card col-12 col-md-6 col-xl-4">
            <b-card-header class="signIn-card-header">Sign in</b-card-header>
            <form ref="Sign_in">
                <b-card-body style="padding: 0.75rem !important;">
                    <b-form-group
                            label="Email"
                            label-for="email">
                        <b-form-input
                                id="email"
                                type="email"
                                v-model="signInData.email"
                                autofocus
                                required/>
                    </b-form-group>
                    <b-form-group
                            label="Password"
                            label-for="password">
                        <b-form-input
                                id="password"
                                type="password"
                                v-model="signInData.password"
                                required/>
                    </b-form-group>
                </b-card-body>
                <b-card-footer class="signIn-card-footer">
                    <div class="flex-grow-1"></div>
                    <v-btn class="btn-primary" @click="signIn" type="submit" :style="primaryStyle"
                           :loading="singingIn" :disabled="singingIn">Sign in
                    </v-btn>
                </b-card-footer>
            </form>
        </b-card>
    </b-container>
</template>

<script>
    import AuthorizationRepository from "../../repositories/authorization.repository";

    export default {
        data() {
            return {
                singingIn: false,
                signInData: AuthorizationRepository.blankSignInData(),
                returnRoute: this.$route.params.currentroute
            }
        },
        created() {
            this.returnRoute = this.$route.params.currentroute;
            if (localStorage.getItem('signedIn') === 'true' && new Date().getTime() < new Date(Date.parse(localStorage.getItem('signInExpiresAt'))).getTime()) {
                this.$router.push({path: `/dashboard`});
            }
        },
        methods: {
            signIn() {
                if (this.$refs.Sign_in.checkValidity() && this.checkCredentials()) {
                    this.singingIn = true;
                    AuthorizationRepository.login(this.signInData).then(res => {
                        this.singingIn = false;
                        this.$bvToast.toast(`Successful login. Welcome back, you will be redirected in a moment.`, {
                            title: `successful login.`,
                            variant: 'success',
                            solid: true
                        });

                        localStorage.setItem('signedIn', true);
                        localStorage.setItem('signInExpiresAt', res.data['loginExpiresAt']);

                        this.$emit('authChanged');

                        setTimeout(() => {
                            this.successfulLogin();
                        }, 1500);
                    }).catch(error => {
                        console.error(error);
                        this.singingIn = false;
                        if (error.response.status === 500) {
                            this.$bvToast.toast('The email and/or password was incorrect.\n', {
                                title: `Bad credentials`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            this.$bvToast.toast('Looks like something went wrong on the server while logging in.', {
                                title: `server error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }

                    });
                }
            },
            checkCredentials() {
                return AuthorizationRepository.validate.email(this.signInData.email);
            },
            successfulLogin() {
                if (this.returnRoute !== undefined && this.returnRoute.fullPath !== undefined && this.returnRoute.fullPath !== "/sign-in") {
                    this.$router.push({path: this.$route.params.currentroute.fullPath});
                } else {
                    this.$router.push({path: `/dashboard`});
                }
            }
        }
    }
</script>

<style>
    .signIn-card-header {
        background-color: var(--main-color);
        font-weight: bold;
    }

    .signIn-card {
        padding: 0 !important;
        height: 350px;
        top: calc(50vh - (350px / 2));
        box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12) !important;
    }

    .signIn-card > div {
        padding: 0.75rem !important;
    }

    .ioImage {
        position: fixed;
        height: 175px;
        width: 300px;
        top: calc(20vh - (175px / 2));
        right: 0;
    }

    .signIn-card-footer {
        background-color: white;
        display: flex;
    }

</style>
